<template>
  <section>
    <header>
      <h1 class="page-header">Contact</h1>
    </header>
    <h3>Email</h3>
    <p><a href="maillto:contact@sixplusholdem.com">contact@sixplusholdem.com</a></p>
    <h3>Live chat</h3>
    <p>If the icon on the bottom right of this page says "Hello", you can click it to start a live chat.</p>
    <h3>Skype/phone</h3>
    <p>I'd be more than happy to Skype or talk on the phone. Just shoot me an email and we'll set up a call.</p>
    <h3>In person</h3>
    <p>I'd also be more than happy to meet up in person. I live in Vegas so if you live here or are in town, shoot me an email and we'll set up a time to hang out.</p>
    <hr>
    <section class="well">
      <h3>I really do want to hear from you!</h3>
      <p>I know that's something that everyone says, but few actually mean. I know that as a consumer you've been trained to think "they're probably just saying that". But I really do mean it. I promise.</p>
      <p>I talk about my reasons a little more <router-link to="/faq#general-2EWuS">in this FAQ question</router-link>, but this about sums it up:</p>
      <tweet id="898476047263518720"></tweet>
      <p>I also list out some good reasons to reach out <router-link to="/faq#general-G9yAY">in a different FAQ question</router-link>.</p>
    </section>
  </section>
</template>

<script>
import { Tweet } from 'vue-tweet-embed';

export default {
  name: 'ppt-contact',
  components: {
    'tweet': Tweet,
  },
};
</script>

<style lang="scss" scoped>
  section {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contact.vue